/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { DocumentView, IDocumentViewOwnProps, IDocumentViewDispatchProps, IDocumentViewStateProps } from "../../components/document/documentView";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IDocumentViewOwnProps): IDocumentViewStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.event) || Base.isNullOrUndefined(applicationState.event.eventEdit)) {
        return {
            item: null,
            returnUrl: ""
        };
    }
    const documentView = applicationState.document.documentView;
    return {
        item: documentView.item,
        returnUrl: documentView.returnUrl,
    };
}

export function mapDispatchToProps(dispatch: storeEffects.DocumentThunkDispatch): IDocumentViewDispatchProps {
    return {
        loadDocumentView: (documentVersionId: string, companyId: string) => dispatch(storeEffects.getDocumentView(documentVersionId, companyId)),
        resetDocumentView: () => dispatch(storeActions.documentViewReset())
    };
}

export default withRouter(connect<IDocumentViewStateProps, IDocumentViewDispatchProps, IDocumentViewOwnProps>(mapStateToProps, mapDispatchToProps)(DocumentView));